$(document).ready(function () {
    let inputCounts = $('.input--count')

    if (inputCounts.length) {
        inputCounts.on('input.changed', function (e) {
            localStorage.setItem('scrollPosition', window.scrollY);
            let form = e.target.closest('form#eshopCartForm')
            if (form) {
                $(form).trigger('submit')
            }
        })

        $('.input__descent').on('click', function () {
            let target = $(this)
            if (parseInt(target.siblings('input').val()) > 1) {
                let i = parseInt(target.siblings('input').val()) - 1
                target.siblings('input').val(i)
                inputCounts.trigger('input.changed', target)
            }
        })

        $('.input__ascent').on('click', function () {
            let target = $(this)
            let i = parseInt(target.siblings('input').val()) + 1
            target.siblings('input').val(i)
            inputCounts.trigger('input.changed', target)
        })
    }
})
